(function () {
  'use strict';

  angular
    .module('web2print')
    .controller('MainController', MainController);

  MainController.$inject = ['$log', '$scope', '$localStorage', '$state', '$window', '$translate',
    'ParcelTypes', 'PreloadFactory', 'CountrySelectionFactory', 'Common'];

  /* @ngInject */
  function MainController ($log, $scope, $localStorage, $state, $window, $translate, ParcelTypes,
    PreloadFactory, CountrySelectionFactory, Common) {
    const vm = this;
    vm.getParcelTypesForCountry = getParcelTypesForCountry;
    vm.isCustomerCompany = $localStorage.isCustomerCompany;
    vm.hasPrintedShippinglabel = false;
    vm.isSmallScreen = false;
    vm.setCustomerType = setCustomerType;
    vm.getCurrentStage = getCurrentStage;
    vm.openHumanyContact = openHumanyContact;
    vm.setPrintedShippinglabel = setPrintedShippinglabel;

    if (!$localStorage.receiverCountryCode) {
      $localStorage.receiverCountryCode = Common.getServiceCountry();
    }
    $scope.$on('changeLanguage', function (events, language) {
      console.log('Changing language');
      // getParcelTypes($localStorage.receiverCountryCode, language);
    });

    activate();

    //////////////////////////

    function activate () {
      $log.log('MainController : activate');
      // getParcelTypes().then(preloadImages);

      initResizeListener();

      vm.isSmallScreen = checkIfScreenSizeIsSmall();
    }

    function getCurrentStage () {
      return $state.current.name.replace('main.', '');
    }

    function getParcelTypes (countryCode, language) {
      language = language || $translate.proposedLanguage() || $translate.use();
      return ParcelTypes.get(countryCode, language).then(function (parcelTypes) {
        vm.parcelTypes = parcelTypes;
        return parcelTypes;
      });
    }
    function getParcelTypesForCountry ($item) {
      $localStorage.receiverCountryCode = $item.countryCode;
      getParcelTypes($item.countryCode);
    }

    function setCustomerType (value) {
      $localStorage.isCustomerCompany = value;
      vm.isCustomerCompany = value;
    }

    function setPrintedShippinglabel () {
      vm.hasPrintedShippinglabel = true;
    }

    function checkIfScreenSizeIsSmall () {
      const w = $window.innerWidth;
      return w < 768;
    }

    function initResizeListener () {
      angular.element($window).bind('resize', function () {
        vm.isSmallScreen = checkIfScreenSizeIsSmall();
        $scope.$digest();
      });
    }

    function openHumanyContact () {
      $scope.$broadcast('humany:openFloatingWidget');
    }

    $scope.$on('receiptDestroyed', function () {
      vm.hasPrintedShippinglabel = false;
    });
  }
})();
